import React from "react";
import ReactDOM from "react-dom/client";
import { getUniqueInteger } from "../../functions/math";
import SvgSprite from "../../components/Utils/SvgSprite";
import Avatar from "../../components/Utils/Image/Avatar";

const $ = window.jQuery

// function SvgSprite({ id, section='svg_sprites_common' }){
//     // let href = `championship/image/svg/sprites/${section}.svg#${id}`
//     let href = `${window.static_urls[section]}#${id}`
//     return (
//         <div class="svg-icon">
//             <svg>
//                 <use href={href}></use>
//             </svg>
//         </div>
//     )
// }

function Item({ source, onDelete }){

    return (
        <div class="list-form-item">
            <Avatar object={source.player} className="list-form-item__image" />
            {/* <div class="list-form-item__image">
                <img src={source.player.image} alt="" />
            </div> */}
            <div class="list-form-item__title">
                {source.player.first_name} {source.player.last_name} {source.player.middle_name}
            </div>
            <button class="list-form-item__button button -link -gray js-modal-invoker" onClick={onDelete}>
                Удалить
                <SvgSprite id={"trash"} />
            </button>
        </div>
    )
}

class Form extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            items: [],
            messages: [],
            isLoading: false,
        }
        this.messages = []
        this.loadList()
        this.initSelect()
    }
    initSelect(){

        const $search_select = $(`#${this.props.search_select_id}`)

        $search_select.click(function(event){
            event.stopPropagation()
        })
        $search_select.selectSearch({
            onSelect: (data, $select) => {
                this.addItem(data)
            },
            onListRender: (list) => {
                list.forEach((el, i) => {
                  const $el = $(el)
                  const data = $el.data('item')
                  if (data.image_id) {
                    $el.find('img').attr('src', data.image)
                  }
                })
              }
        })
    }
    loadList(){
        const that = this
        this.setLoading(true)
        $.ajax({
            url: this.props.urls.list,
            method: 'GET',
            headers: {
                'Accept':'application/json',
                'X-CSRFToken': that.props.csrf_token
            },
            success: function(data, status, event){
                that.setState({
                    items: data.data.admins
                });
                that.setLoading(false)
            }
        })
    }
    addItem(data){
        this.clearMessages()
        const id_exits = this.state.items.find((item) => item.id === data.id)
        if(id_exits){
            this.applyMessage({
                // text: `Пользователь с id ${data.id} уже есть в списке`,
                text: `Пользователь ${data.name} уже есть в списке`,
                level: 'warning'
            })
            return
        }
        this.setState({
            items: this.state.items.concat([{
                id: data.id,
                player: {
                    first_name: data.name,
                    image: data.image,
                }
            }])
        })
    }
    removeItem(remove_id){
        this.clearMessages()
        this.setState({
            items: this
                .state
                .items
                .filter(
                    (item) => item.id != remove_id
                )
        })
    }
    cancel(){
        this.clearMessages()
        this.loadList()
    }
    save(){
        this.clearMessages()
        this.setLoading(true)
        const data = {
            csrfmiddlewaretoken: this.props.csrf_token,
            items: this.state.items,
        }
        const that = this
        $.ajax({
            url: this.props.urls.list,
            method: 'POST',
            headers: {
                'Accept':'application/json',
                'Content-Type': 'application/json',
                'X-CSRFToken': that.props.csrf_token
            },
            processData: false,
            data: JSON.stringify(data),
            success: function(data, status, event){
                that.setState({
                    items: data.data.admins
                });
                that.setLoading(false)
                that.applyMessages(data.messages)
            },
            error: function(jqXHR){
                that.handleResponseError(jqXHR)
            }
        })
    }
    handleResponseError(jqXHR){
        let error_message = ''
        try{
            const error_data = JSON.parse(jqXHR.responseText)           
            error_message = error_data.error
        }catch(err){
            error_message = 'Произошла непредвиденная ошибка'
        }
        this.setLoading(false)
        this.applyMessage({
            text: error_message ,
            level: 'error',
        })
    }
    clearMessages(){
        this.messages = []
        this.applyMessages()
    }
    addMessages(messages){    
        this.messages = this.messages.concat(messages)
        console.log(this.messages, messages)
    }
    addMessage(message){
        this.addMessages([{
            id: getUniqueInteger(),
            text: message.text || '',
            level: message.level || 'info',
        }])
    }
    /**
     * 
     * @param {*} messages 
     * 
     * to avoid race condition in sync function
     * at first add messages using addMessage 
     * or addMessage and then apply state
     */
    applyMessages(messages = []){
        if(messages){
            this.addMessages(messages)
        }
        this.setState({
            messages: this.messages
        })
    }
    applyMessage(message){
        this.addMessage(message)
        this.applyMessages()
    }
    setLoading(bool = true){
        this.setState({
            isLoading: bool
        })
    }
    render() {
        return (
            <div class="list-form">
                <div class="list-form__list">
                    <div className={`list-form-loader ${this.state.isLoading ? "-active" : ""}`}>
                        <div class="list-form-loader__spinner"></div> 
                    </div>
                    {this.state.items.map(item => (
                      <Item 
                        key={item.id}
                        source={item}
                        onDelete={this.removeItem.bind(this, item.id)}
                        />
                    ))}
                </div>
                <div class="list-form__messages">
                    {this.state.messages.map(message => (
                        <div key={message.id} className={`form-message -lvl-${message.level}`}>
                            {message.text}
                        </div>
                    ))}
                </div>
                <div class="list-form__actions">
                    <button class="button" onClick={this.cancel.bind(this)}>
                        Отменить
                    </button>
                    <button type="submit" onClick={this.save.bind(this)} class="button -fill js-submit">
                        Сохранить
                    </button>
                </div>
            </div>
        )
    }
}

function init( config ){
    const dom_root = config.root
    const root = ReactDOM
        .createRoot(dom_root)
    // TODO: https://docs.djangoproject.com/en/4.2/howto/csrf/#using-csrf-protection-with-ajax
    const csrf_token = document.getElementsByName('csrfmiddlewaretoken')[0].value
    root.render(
        <Form 
            urls={config.urls}
            search_select_id={config.search_select_id}
            csrf_token={csrf_token}
            />
    );
}

export {
    init
}